<p-progressBar
  *ngIf="isShowProgressBar$ | async"
  mode="indeterminate"
></p-progressBar>
